// Simple Navigation Script - Header, Footer & Navigation (ES Module)

// Add CSS files dynamically
function addCSS(id, href) {
     if (document.getElementById(id)) return;
     const link = document.createElement('link');
     link.id = id;
     link.rel = 'stylesheet';
     link.href = href;
     document.head.appendChild(link);
}

// Inject Header HTML
function injectHeader() {
     const existing = document.querySelector('[data-component="header"]');
     if (!existing) return;

     // Add CSS
     addCSS('nav-css', 'css/nav.css');

     const headerHTML = `
<!-- Header -->
<header class="site-header" style="--nav-link-color:var(--color-text-primary);">
  <div class="nav-bar" role="navigation" aria-label="Navigation principale">
    <!-- Logo -->
    <a class="brand" href="/" aria-label="Accueil">
      <img src="/assets/img/SDGDR/SDGDR-Logo.png" alt="Seb Dubé — Guitares de Rêve" width="160" height="40">
    </a>

    <!-- Inline links -->
    <nav class="nav-row" aria-label="Liens du site">
        <div class="nav-group nav-group--left">
          <a class="nav-link" href="/lereve.html">Le Rêve</a>
          <a class="nav-link" href="/promesses.html">Promesses</a>
        </div>
        <a class="brand-inline" href="/" aria-label="Accueil">
          <img src="/assets/img/SDGDR/SDGDR-Logo.png" alt="Seb Dubé — Guitares de Rêve">
        </a>
        <div class="nav-group nav-group--right">
          <a class="nav-link" href="/salondesreves.html">Salon des Rêves</a>
          <a class="nav-link" href="/contact.html">Contact</a>
        </div>
    </nav>

    <!-- Mobile toggle -->
    <button class="nav-toggle" aria-expanded="false" aria-controls="mobile-menu" aria-label="Open menu">
      <span>Menu</span>
    </button>
  </div>
</header>

<!-- Asset base + optional version for loader (injected via header) -->
<script>
  window.ASSET_BASE = '/dist';
  window.ASSET_VERSION = '2025-09-22-1';
</script>

<!-- Mobile overlay - positioned outside header for proper viewport coverage -->
<div id="mobile-menu" class="nav-overlay" hidden>
  <div class="nav-overlay__inner" role="dialog" aria-modal="true" aria-labelledby="mobile-menu-title">
    <div class="overlay-bar">
      <a class="brand-slim" href="/" aria-label="Accueil">
        <img src="/assets/img/SDGDR/SDGDR-Logo.png" alt="" width="48" height="48">
      </a>
      <button class="overlay-close" aria-label="Close menu">Fermer</button>
    </div>
    <h2 id="mobile-menu-title" class="sr-only">Menu</h2>
    <nav class="nav-overlay__nav" aria-label="Menu mobile">
      <a class="nav-overlay__link" href="/lereve.html">Le Rêve</a>
      <a class="nav-overlay__link" href="/promesses.html">Promesses</a>
      <a class="nav-overlay__link" href="/salondesreves.html">Salon des Rêves</a>
      <a class="nav-overlay__link" href="/contact.html">Contact</a>
      <!-- Mobile-injected links (login) will appear here via JS -->
    </nav>
  </div>
</div>
     `;

     existing.outerHTML = headerHTML;
}

// Inject Footer HTML
function injectFooter() {
     const existing = document.querySelector('[data-component="footer"]');
     if (!existing) return;

     // Add CSS
     addCSS('footer-css', 'css/footer-contact.css');

     const footerHTML = `
<footer id="contact" class="sdgdr-footer">
  <!-- FULL-WIDTH highlight banner (bleeds to device edges) -->
  <div class="footer-banner" role="region" aria-label="Contact banner">
    <h2 class="banner-title">
      <a href="/contact.html" class="banner-link">
        CONTACTEZ NOUS <span class="banner-arrow" aria-hidden="true">↗</span>
      </a>
    </h2>
  </div>

  <!-- Main footer layout: image left, content right on desktop; stacked on mobile -->
  <div class="footer-main">
    <!-- Hero image (kept tall, with mobile overlay strip) -->
    <figure class="footer-hero parallax-bg"
     style="background: url('/assets/img/SDGDR/components/optimized/SDGDR-Footer-1024.webp') center / cover no-repeat; --parallax-origin-y: 0%; --parallax-distance: 10%"
     data-src-nightmare="/assets/img/SDGDR/Nightmare_Footer.png"></figure>

    <!-- Content grid (menu, address, contacts) -->
    <div class="footer-grid">
      <nav class="footer-menu" aria-label="Menu">
        <div class="footer-menu__label" aria-hidden="true">MENU</div>
        <ul>
          <li><a href="/lereve.html">Le Rêve</a></li>
          <li><a href="/promesses.html">Promesses</a></li>
          <li><a href="/salondesreves.html">Salon des Rêves</a></li>
        </ul>
        <a class="to-top" href="#top" aria-label="Remonter en haut">↑</a>
      </nav>

      <address class="footer-address">
        <strong>Seb Dubé – Guitares de Rêve</strong><br>
        12 Rue du Rêve, Montréal, QC<br>
        S3B 2U8, Canada
      </address>

      <div class="footer-contacts">
        <a href="tel:+1-800-BOULE-DANS-GORGE">1-800-BOULE-DANS-GORGE <i>#OneForeverGary</i></a>
        <a href="mailto:contact@sebdubeguitaresdereve.com">contact@sebdubeguitaresdereve.com</a>
        <div class="more-links">
          <a href="#">Instagram</a>
          <a href="#">Facebook</a>
          <a href="#">Presse</a>
        </div>
      </div>
    </div>
  </div>
</footer>
     `;

     existing.innerHTML = footerHTML;
}

// Initialize navigation event listeners
function initNavigation() {
     const navToggle = document.querySelector('.nav-toggle');
     const mobileMenu = document.getElementById('mobile-menu');
     const overlayClose = document.querySelector('.overlay-close');

     if (navToggle && mobileMenu) {
          navToggle.addEventListener('click', function () {
               const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
               navToggle.setAttribute('aria-expanded', !isExpanded);
               mobileMenu.setAttribute('data-state', isExpanded ? 'closed' : 'open');
               mobileMenu.hidden = isExpanded;
          });
     }

     if (overlayClose && mobileMenu) {
          overlayClose.addEventListener('click', function () {
               navToggle.setAttribute('aria-expanded', 'false');
               mobileMenu.setAttribute('data-state', 'closed');
               mobileMenu.hidden = true;
          });
     }
}

// Main initialization function
export function initSimpleNav() {
     injectHeader();
     injectFooter();
     initNavigation();
}

// Auto-initialize
if (document.readyState === 'loading') {
     document.addEventListener('DOMContentLoaded', initSimpleNav);
} else {
     initSimpleNav();
}
